<div class="parent-group" fxLayout="column">
  <div fxLayout="column" fxFlex class="content-container">
    <div
      fxLayout="column"
      fxFlex
      class="report-table custom-page-scroll"
      [hidden]="!(dataSource.data && dataSource.data.length > 0)">
      <table
        #reportTable
        mat-table
        [dataSource]="dataSource"
        matSort
        class="content-table">
        <ng-container
          *ngFor="let columnName of displayedColumns; let idx = index"
          [matColumnDef]="columnName">
          <ng-container [ngSwitch]="columnName">
            <ng-container *ngSwitchDefault>
              <th
                mat-header-cell
                *matHeaderCellDef
                class="content-header"
                mat-sort-header
                disableClear>
                <div>
                  {{ columnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
          </ng-container>

          <ng-container>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchDefault>{{
                  element[columnName]
                }}</ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let entry"
          class="content-row"></tr>
      </table>
    </div>
    <div [hidden]="!(dataSource.data && dataSource.data.length > 0)">
      <mat-paginator
        #paginator
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[1, 10, 15, 25, 50, 100]"></mat-paginator>
    </div>
    <div class="content-loading" *ngIf="isLoading">
      <mat-spinner class="margin-auto"></mat-spinner>
    </div>
  </div>
</div>
